import '@/assets/fonts.css'
import '@/assets/main.css'
import '@/api/interceptors'

/** 开发环境下 Chromium 对 ResizeObserver 的已知噪声，会触发 Vite 未捕获错误提示 */
if (import.meta.env.DEV) {
  window.addEventListener(
    'error',
    (e) => {
      if (String(e.message).includes('ResizeObserver')) {
        e.stopImmediatePropagation()
      }
    },
    true,
  )
}

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

dayjs.locale('zh-cn')

import { http } from '@/api'
import Antd from 'ant-design-vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '@/App.vue'
import router from '@/router'
import { vPerm } from '@/directives/perm'
import { useThemeStore } from '@/stores/theme'
import { msg, msgbox, notify } from '@/plugins/message'

const app = createApp(App)

app.config.globalProperties.$http = http
app.config.globalProperties.$msg = msg
app.config.globalProperties.$msgbox = msgbox
app.config.globalProperties.$notify = notify

app.use(Antd)
const pinia = createPinia()
app.use(pinia)
app.directive('perm', vPerm)
useThemeStore().init()
app.use(router)

// 立即挂载：由 App.vue 在 router.isReady() 完成前展示启动占位，避免长时间空白 #app；
// 路由仍会在首屏完成后再渲染 RouterView，不会闪出受保护页面再跳登录。
app.mount('#app')
